import React, { useEffect, useState } from "react";
import PageBuilderRowService from "../../../../../services/page-builder-row.service";
import {
    Grid,
    Button,
    DialogActions,
    DialogContent,
    Divider,
    TextField
} from "@material-ui/core";
import Loading from "../../../../../components/loading";
import DialogTitle from "../../../../../components/dialog-title";
import { Form, Formik } from "formik";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import glassesService from "../../../../../services/glasses.service";
import { useErrorHandler } from "../../../../../hooks";


export default function SelectGlassModal(props) {
    const { close, data } = props;

    const errorHandler = useErrorHandler();

    const [waiting, setWaiting] = useState(false);
    const [searchOption, setSearchOption] = useState("")
    const [searchKeys, setSearchKeys] = useState("")
    const [defaultValues, setDefaultValues] = useState(null)
    const [options, setOptions] = useState([])

    const getOptionLabel = () => {
        const labelSelector = "title";
        if (!labelSelector) return;
        if (typeof labelSelector === "string") {
            return (option) => `${option[labelSelector]}`;
        }
        return labelSelector;
    };

    const handleSubmit = async () => {
        setWaiting(true);
        let op = await PageBuilderRowService.selectGlassesPageBuilderRowContent(data.id, searchKeys.map(item => item.value));
        setWaiting(false);

        const { error } = op;
        if (error) return errorHandler(error);

        close(true);
    };

    const searchInGlasses = async (searchKey) => {
        let query = [
            `page=1`,
            `perpage=20`,
            `search=${searchKey}`,
        ];
        glassesService.getGlasses(query).then(res => {
            if(res?.data?.items){
                setOptions(res?.data?.items.map(item => ({
                    title: `${item.name} - ${item.brand.name}`,
                    value: item.id
                })))
            }
        }).catch(err => {})
    }

    useEffect(() => {
        searchInGlasses(searchOption)
    }, [searchOption]);

    useEffect(() => {
        let contents = [];
        if(data.contents){
            contents = JSON.parse(data.contents);
            const op = contents.map(item => ({
                title: `${item.name} - ${item.brand.name}`,
                value: item.id
            }));

            setDefaultValues(op);
            setOptions(op);
            setSearchKeys(op);
        } else{
            setDefaultValues([])
        }
    }, [])

    if(defaultValues === null){
        return null
    }

    return (
        <Loading isLoading={waiting} fullPage={true} overlay>
            <DialogTitle onClose={() => close()}>انتخاب عینک</DialogTitle>
            <Divider />
            <Formik
                initialValues={{}}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, values }) => (
                    <Form autoComplete="off">
                        <DialogContent style={{ overflowX: "hidden" }}>
                            <Grid container spacing={2}>
                                <Grid items xs={12} className="p-1">
                                    <MuiAutocomplete
                                        multiple={true}
                                        options={options}
                                        onKeyUp={(e) => setSearchOption(e.target.value)}
                                        getOptionLabel={getOptionLabel()}
                                        defaultValue={defaultValues}
                                        noOptionsText="هیچ گزینه ای یافت نشد."
                                        onChange={(e, values) => setSearchKeys(values)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                label={"عینک"}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                ثبت
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Loading>
    );
}
